// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"33d35c19","16":"f9cb6c73","300":"d8b5e6ea","453":"127be8e2","597":"f4cf11ff","890":"1713aca0","915":"bb694248","975":"7ccb0c9f"}[chunkId] + ".chunk.js";
};